import { Alert } from 'foundations-components/transitional/components/Alert';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
const ErrorMessageWithRetry = ({
  retry,
  title
}) => {
  return /*#__PURE__*/_jsx(Alert, {
    use: "inline",
    type: "danger",
    titleText: title,
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "routing-ui.shared.alerts.RETRY.message_jsx",
      options: {
        onClick: retry,
        underline: true,
        use: 'on-bright'
      },
      elements: {
        Link
      }
    })
  });
};
ErrorMessageWithRetry.displayName = 'ErrorMessageWithRetry';
export default ErrorMessageWithRetry;